import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromQualityMeasureSurvey from '@store/reducers/quality-measure-survey/quality-measure-survey.reducer';

export const selectQualityMeasureSurveyState = createFeatureSelector<fromQualityMeasureSurvey.State>(
  fromQualityMeasureSurvey.qualityMeasureSurveyFeatureKey
);

export const selectQualityMeasureSurvey = createSelector(
  selectQualityMeasureSurveyState,
  (state) => state.survey
);

export const selectQualityMeasureSurveyLoading = createSelector(
  selectQualityMeasureSurveyState,
  (state) => state.loading
);

export const selectQualityMeasureSurveySaving = createSelector(
  selectQualityMeasureSurveyState,
  (state) => state.saving
);

export const selectQualityMeasureSurveyExporting = createSelector(
  selectQualityMeasureSurveyState,
  (state) => state.exporting
);
